export enum GetDocumentActionTypes {
    REQUEST = '@@document/get-document/request',
    SUCCESS = '@@document/get-document/success',
    ERROR = '@@document/get-document/error'
}
